import { render } from "./AssessmentActions.vue?vue&type=template&id=3bb08842"
import script from "./AssessmentActions.vue?vue&type=script&lang=js"
export * from "./AssessmentActions.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__